import { useEffect, useState } from 'react'
import { loadSessionOnce, type SessionResult } from './api/client'

export function App() {
  const [state, setState] = useState<SessionResult | null>(null)

  const loadSession = () => {
    void loadSessionOnce().then(setState)
  }

  useEffect(() => {
    loadSession()
  }, [])

  if (!state) return <p className="status">Caricamento…</p>
  if (state.kind === 'beta_required') return <AccessForm />
  if (state.kind === 'error')
    return (
      <main className="shell">
        <p role="alert">Servizio non disponibile ({state.message}).</p>
        <button onClick={loadSession}>Riprova</button>
      </main>
    )
  return (
    <main className="shell">
      <h1>La Casa delle Maree</h1>
      <p>
        Sessione {state.session.playerId.slice(0, 8)} · variante {state.session.variant}
      </p>
    </main>
  )
}

function AccessForm() {
  const invalid = new URLSearchParams(window.location.search).get('access') === 'invalid'
  return (
    <main className="shell">
      <h1>La Casa delle Maree</h1>
      <form method="get" action="/api/v1/access">
        <label>
          Codice di accesso
          <input name="code" autoComplete="off" autoCapitalize="characters" required />
        </label>
        <button type="submit">Entra</button>
        {invalid && <p role="alert">Codice non valido.</p>}
      </form>
    </main>
  )
}
